/**
 * Reasons a booking was marked «Dukket ikke opp» (no-show).
 * The key is stored on calendarEvent.didNotShowReason; the label is shown in the UI.
 * Fixed list on purpose: the overview needs comparable categories across clinics.
 */
export const NO_SHOW_REASONS = [
    { key: 'unknown', label: 'Ukjent' },
    { key: 'ownerForgot', label: 'Glemt av eier' },
    { key: 'noSmsReminder', label: 'Ikke varslet på SMS' },
    { key: 'wrongBooking', label: 'Booket feil' },
    { key: 'animalGone', label: 'Dyret er borte' },
    { key: 'other', label: 'Annet' },
];

export const NO_SHOW_REASON_DEFAULT = 'unknown';

export const NO_SHOW_REASON_DATALIST = NO_SHOW_REASONS.map(r => [r.key, r.label]);

export function noShowReasonLabel(key) {
    if (!key) {
        return '';
    }
    const reason = NO_SHOW_REASONS.find(r => r.key === key);
    return reason ? reason.label : key;
}
